import axios from "axios";

// export const baseURL = "http://52.220.255.148:4000/api/v1";
export const baseURL = "https://api-bookings.physica.fit/api/v1"
// export const baseURL = "http://54.151.175.165:4000/api/v1";

const instance = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

export default instance;